import React from "react";
import TopNav from "../components/TopNav";
import AppShell from "../components/AppShell";
import SEO from "../components/SEO";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import CratesSection from "../components/CratesSection";
import Leaderboard from "../components/Leaderboard";
import GamesSection from "../components/GamesSection";
import Footer from "../components/Footer";

export default function Landing() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-white/60"><Loader2 className="animate-spin" /></div>;
  const body = (
    <div className="relative z-10">
      <SEO
        title="Slots worth spinning"
        description="Gumble Studio builds math-first casino games exclusive on Stake — high-volatility slots, burst games, weekly crates and leaderboard prizes."
        path="/"
      />
      <Hero />
      <Marquee />
      <CratesSection />
      <Leaderboard />
      <GamesSection />
      <Footer />
    </div>
  );
  if (user) return <AppShell>{body}</AppShell>;
  return (
    <div className="relative min-h-screen text-white">
      <TopNav />
      {body}
    </div>
  );
}
